var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgDeleteDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2837 9.5L13.9952 17M10.0048 17L9.71635 9.5M18.023 6.82547C18.308 6.86851 18.592 6.91456 18.875 6.96358M18.023 6.82547L17.1332 18.3938C17.058 19.3707 16.2434 20.125 15.2637 20.125H8.73631C7.75655 20.125 6.94198 19.3707 6.86683 18.3938L5.97696 6.82547M18.023 6.82547C17.0677 6.6812 16.1013 6.57071 15.125 6.49527M5.125 6.96358C5.40798 6.91456 5.69198 6.86851 5.97696 6.82547M5.97696 6.82547C6.93231 6.6812 7.89874 6.57071 8.875 6.49527M15.125 6.49527V5.73182C15.125 4.74902 14.3661 3.92853 13.3838 3.8971C12.9244 3.8824 12.463 3.875 12 3.875C11.537 3.875 11.0756 3.8824 10.6162 3.8971C9.63388 3.92853 8.875 4.74902 8.875 5.73182V6.49527M15.125 6.49527C14.0938 6.41558 13.0516 6.375 12 6.375C10.9484 6.375 9.9062 6.41558 8.875 6.49527",
    stroke: "#002244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDeleteDesign);
export default __webpack_public_path__ + "static/media/svg_delete_design.e5a9906c5e0e9c1b3a5bd1c099033bb6.svg";
export { ForwardRef as ReactComponent };